import { createStyles } from 'antd-style';
import colorToken from '../../utils/colorToken';
/**
 * 通知模态框样式
 */
const useStyles = createStyles(({ token, css }) => {
  return {
    // 通知模态框容器
    notificationModal: css`
      position: fixed;
      top: 30px;
      right: 20px;
      bottom: 0;
      left: auto;
      width: 400px;
      height: 90%;
      background: linear-gradient(354deg, #FFF 27.54%, #F7FEFF 64.29%, #EFF 84.68%);
      z-index: 1000;
      border: 1px solid ${colorToken.colorBorderSecondary};
      border-right-width: 5px;
      border-bottom-width: 5px;
      border-radius: 10px;
      overflow: hidden;
      pointer-events: auto;
      display: flex;
      flex-direction: column;
    `,
    notificationPanel: css`
      position: relative;
      width: 100%;
      height: 100%;
      background: linear-gradient(354deg, #FFF 27.54%, #F7FEFF 64.29%, #EFF 84.68%);
      border: 1px solid ${colorToken.colorBorderSecondary};
      border-right-width: 5px;
      border-bottom-width: 5px;
      border-radius: 10px;
      overflow: hidden;
      pointer-events: auto;
      display: flex;
      flex-direction: column;
    `,
    
    // 关闭按钮
    closeButton: css`
      position: absolute;
      top: 0;
      right: 0;
      width: 32px;
      height: 32px;
      border: none;
      background: ${colorToken.colorAssist5};
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: ${colorToken.colorTextOnLightBase};
      z-index: 1001;
      transition: all 0.3s ease;
      
      &:hover {
        background: rgba(0, 0, 0, 0.05);
        color: ${colorToken.colorSuccess};
      }
      
      .anticon {
        font-size: 16px;
      }
    `,
    
    // 模态框头部
    modalHeader: css`
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 24px 32px 0;
    `,
    
    // 标题
    title: css`
      font-family: 'OPPOSans', sans-serif;
      font-size: 24px;
      font-weight: 600;
      color: ${colorToken.colorTextOnLightBase};
      margin: 0 auto;
      position: relative;
      padding-left: 56px;
      min-height: 46px;
      line-height: 46px;
      &::before {
        content: '';
        position: absolute;
        top: 3px;
        left: 38px;
        width: 46px;
        height: 46px;
        border-radius: 50%;
        display: inline-block;
        background: linear-gradient(70deg, #01FF17 -6.82%, rgba(255, 255, 255, 0.00) 55.53%);
        z-index: 1;
      }
    `,
    
    // 全部已读按钮
    markAllReadButton: css`
      background: ${colorToken.colorAssist5};
      border: 1px solid ${colorToken.colorTextBase};
      border-radius: 50px;
      padding: 2px 8px;
      font-size: 12px;
      font-family: 'OPPOSans', sans-serif;
      color: ${colorToken.colorTextBase};
      cursor: pointer;
      transition: all 0.3s;
      
      &:hover {
        background: ${colorToken.colorSuccess};
        color: ${colorToken.colorAssist5};
        border-color: ${colorToken.colorSuccess};
      }
    `,
    
    // 筛选按钮
    filterButton: css`
      background: ${colorToken.colorAssist7};
      border: 1px solid ${colorToken.colorTextBase};
      border-radius: 50px;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s;
      
      &:hover {
        background: ${colorToken.colorSuccess};
        border-color: ${colorToken.colorSuccess};
      }
    `,
    
    // 未读指示器
    unreadIndicator: css`
      width: 8px;
      height: 8px;
      background: linear-gradient(135deg, ${colorToken.colorSuccess} 0%, rgba(255, 255, 255, 0) 66.53%);
      border-radius: 50%;
      position: absolute;
      top: 20px;
      right: 20px;
    `,
    
    // 分类标签容器
    categoryTabs: css`
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 12px 16px;
      gap: -15px;
      position: relative;
      
      .ant-tabs-nav {
        margin: 0;
        width: 100%;
        &::before{
           border-bottom: none;
        }
      }
      
      .ant-tabs-tab {
        margin: 0;
        background: transparent;
        border: none;
        font-family: 'OPPOSans', sans-serif;
        font-size: 16px;
        color: ${colorToken.colorTextOnLightBase};
        transition: all 0.3s;
        
        &:hover {
          color: ${colorToken.colorSuccess};
        }
      }
      
      .ant-tabs-tab-active {
        .ant-tabs-tab-btn {
          color: ${colorToken.colorTextOnLightBase} !important;
          &::after{
            content: '';
            position: absolute;
            left: 0px;
            bottom: 8px;
            width: 100%;
            height: 8px;
            border-radius: 10px;
            background: #01FF17;
            z-index: -1;
          }
        }
      }
      
      .ant-tabs-ink-bar {
        display: none;
      }
    `,
    
    // 通知列表容器
    notificationList: css`
      flex: 1;
      overflow-y: auto;
      padding: 0 32px 44px;
      
      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
      
      &::-webkit-scrollbar-track {
        background: ${colorToken.colorBgBase};
        border-radius: 2px;
      }
      
      &::-webkit-scrollbar-thumb {
        background: ${colorToken.colorBorder};
        border-radius: 2px;
        
        &:hover {
          background: ${colorToken.colorTextSecondary};
        }
      }

      scrollbar-width: none;
      -ms-overflow-style: none;
    `,
    
    // 通知项容器
    notificationItem: css`
      margin-bottom: 16px;
      border-radius: 4px;
      transition: all 0.3s;
    `,
    
    // 通知项背景
    notificationBackground: css`
      background: ${colorToken.colorAssist5};
      border-radius: 4px;
      padding: 8px;
      border: 1px solid ${colorToken.colorTextBase};
      box-shadow: 4px 4px 0px 0px ${colorToken.colorTextBase};
    `,
    
    // 通知项头部
    notificationHeader: css`
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 4px;
    `,
    
    // 左侧信息
    headerLeft: css`
      display: flex;
      align-items: center;
      gap: 4px;
    `,
    
    // 类型图标
    typeIcon: css`
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${colorToken.colorAssist7};
    `,
    
    // 类型文本
    typeText: css`
      font-family: 'OPPOSans', sans-serif;
      font-size: 12px;
      color: ${colorToken.colorTextOnLightBase};
    `,
    
    // 未读红点
    unreadDot: css`
      width: 6px;
      height: 6px;
      background: ${colorToken.colorError};
      border-radius: 50%;
      margin-left: 4px;
    `,
    
    // 右侧信息
    headerRight: css`
      display: flex;
      align-items: center;
      gap: 11px;
    `,
    
    // 时间
    time: css`
      font-family: 'Poppins', sans-serif;
      font-size: 12px;
      font-weight: 500;
      color: ${colorToken.colorTextOnLightSecondary};
    `,
    
    // 更多按钮
    moreButton: css`
      color: ${colorToken.colorTextOnLightSecondary};
      cursor: pointer;
      padding: 2px;
      
      &:hover {
        color: ${colorToken.colorSuccess};
      }
    `,
    
    // 通知内容
    notificationContent: css`
      display: flex;
      gap: 12px;
      align-items: flex-start;
      padding-left: 0;
    `,
    
    // 用户头像
    userAvatar: css`
      width: 46px;
      height: 46px;
      border-radius: 50%;
      overflow: hidden;
      flex-shrink: 0;
      border: 1px solid ${colorToken.colorTextBase};
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    `,
    
    // 内容区域
    contentArea: css`
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 8px;
      min-width: 0;
    `,
    
    // 用户名
    userName: css`
      font-family: 'OPPOSans', sans-serif;
      font-size: 14px;
      color: ${colorToken.colorTextOnLightBase};
      cursor: pointer;
      transition: color 0.3s;
      
      &:hover {
        color: ${colorToken.colorSuccess};
      }
    `,
    
    // 消息内容
    messageContent: css`
      font-family: 'OPPOSans', sans-serif;
      font-size: 14px;
      color: ${colorToken.colorTextOnLightBase};
      line-height: 1.32;
      word-break: break-word;
      cursor: pointer;
        &:hover {
        color: ${colorToken.colorSuccess};
      }
    `,
    
    // 操作按钮区域
    actionButtons: css`
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 60px;
      flex-shrink: 0;
    `,
    
    // 操作按钮
    actionButton: css`
      width: 100%;
      height: 18px;
      border-radius: 30px;
      padding: 0 7px;
      font-family: 'OPPOSans', sans-serif;
      font-size: 12px;
      font-weight: 400;
      cursor: pointer;
      transition: all 0.3s;
      display: flex;
      align-items: center;
      justify-content: center;
    `,
    
    // 同意按钮
    agreeButton: css`
      background: ${colorToken.colorTextBase};
      color: ${colorToken.colorAssist5};
      border: none;
      
      &:hover {
        background: ${colorToken.colorSuccess};
      }
    `,
    
    // 拒绝按钮
    rejectButton: css`
      background: ${colorToken.colorAssist5};
      color: ${colorToken.colorTextBase};
      border: 1px solid ${colorToken.colorTextBase};
      
      &:hover {
        background: ${colorToken.colorError};
        color: ${colorToken.colorAssist5};
        border-color: ${colorToken.colorError};
      }
    `,
    
    // 已处理状态
    processedStatus: css`
      display: flex;
      align-items: center;
      justify-content: center;
      height: 18px;
      flex-shrink: 0;
    `,
    
    // 已处理文本
    processedText: css`
      font-family: 'OPPOSans', sans-serif;
      font-size: 12px;
      font-weight: 400;
      color: ${colorToken.colorAssist1};
      background: ${colorToken.colorAssist5};
      border: 1px solid ${colorToken.colorAssist1};
      border-radius: 30px;
      padding: 0 7px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 18px;
    `,
    
    // 空状态
    emptyState: css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      padding: 40px 20px;
    `,
    
    // 加载状态
    loadingState: css`
      display: flex;
      justify-content: center;
      align-items: center;
      height: 200px;
    `,
    
    // 加载更多容器
    loadMoreContainer: css`
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 16px 0;
      border-top: 1px solid ${colorToken.colorBorderSecondary};
    `,
    
    // 加载更多加载状态
    loadMoreLoading: css`
      display: flex;
      align-items: center;
      gap: 4px;
      color: ${colorToken.colorAssist1};
      font-size: 14px;
    `,
    
    // 加载更多文本
    loadMoreText: css`
      color: ${colorToken.colorAssist1};
      font-size: 14px;
      cursor: pointer;
      transition: color 0.3s;
      
      &:hover {
        color: ${colorToken.colorSuccess};
      }
    `
  };
});

export default useStyles;
